import { render, staticRenderFns } from "./ModalSizes.vue?vue&type=template&id=8682be3a"
import script from "./ModalSizes.vue?vue&type=script&lang=js"
export * from "./ModalSizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports